<template>
	<div>
		<v-row v-if="error_msg.length !== 0" class="ma-0">
			<v-col cols="12">
				<v-alert type="error" class="mb-0">
					{{ error_msg }}
				</v-alert>
			</v-col>
		</v-row>
		<ProgressLinear v-if="loading"/>
		<v-row class="ma-0 pa-3" justify="space-between">
			<v-btn class="text-capitalize white--text" :color="color" elevation="0" :disabled="!isChanged" @click="onSaveChange()">
				<SaveIcon class="mr-1" :color="'white'" width="20" height="20"/>
				Save changes
			</v-btn>
			<v-btn icon @click="onClose()">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-row>
		<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 240}px`">
			<div class="list-wrap-container">
				<v-row class="ma-0" :align="`start`">
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3">
						<div class="title-text text-purple">Job numbering</div>
						<div class="content-text text-grey">The following settings only apply to new jobs</div>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:9">
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3">
								<div class="bg-color pa-3">
									<div class="content-text text-black">{{ styleTextObj && styleTextObj.title[0] }}</div>
									<div class="number-text text-purple">
										<span>{{ numberA[0] }}</span>
										<span v-if="numberA.length > 1">&nbsp;&nbsp;{{ numberA[1] }}</span>
									</div>
									<v-row v-if="!$vuetify.breakpoint.smAndDown" class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:6" class="content-text text-black px-0">{{ styleTextObj && styleTextObj.contentA[0] }}</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:6" v-if="styleTextObj && styleTextObj.contentA.length > 1" class="content-text text-black">{{ styleTextObj && styleTextObj.contentA[1] }}</v-col>
									</v-row>
									<v-row v-if="$vuetify.breakpoint.smAndDown" class="ma-0">
										<div class="content-text text-black mt-2">
											<span>{{ styleTextObj && styleTextObj.contentA[0] }}</span>
											<span v-if="styleTextObj && styleTextObj.contentA.length > 1">&nbsp;&nbsp;{{ styleTextObj && styleTextObj.contentA[1] }}</span>
										</div>
									</v-row>
								</div>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3">
								<div class="bg-color pa-3">
									<div class="content-text text-black">{{ styleTextObj && styleTextObj.title[1] }}</div>
									<div class="number-text text-purple">
										<span>{{ numberB[0] }}</span>
										<span v-if="numberB.length > 1">&nbsp;&nbsp;{{ numberB[1] }}</span>
									</div>
									<v-row v-if="!$vuetify.breakpoint.smAndDown" class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:6" class="content-text text-black px-0">{{ styleTextObj && styleTextObj.contentB[0] }}</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:6" v-if="styleTextObj && styleTextObj.contentB.length > 1" class="content-text text-black">{{ styleTextObj && styleTextObj.contentB[1] }}</v-col>
									</v-row>
									<v-row v-if="$vuetify.breakpoint.smAndDown" class="ma-0">
										<div class="content-text text-black mt-2">
											<span>{{ styleTextObj && styleTextObj.contentB[0] }}</span>
											<span v-if="styleTextObj && styleTextObj.contentB.length > 1">&nbsp;&nbsp;{{ styleTextObj && styleTextObj.contentB[1] }}</span>
										</div>
									</v-row>
								</div>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3">
								<div class="content-text text-black">{{ styleTextObj && styleTextObj.text }}</div>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4">
								<div class="item-text">Job numbering style</div>
								<v-select
									v-model="selected_numbering_style"
									:items="numbering_style"
									:menu-props="{ bottom: true, offsetY: true}"
									:color="color"
									:item-color="color"
									item-value="id"
									item-text="desc"
									background-color="#FAFAFA"
									return-object
									outlined
									dense
									hide-details
									@change="onChange()"
								>
								</v-select>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4">
								<div class="item-text">Number of digits</div>
								<v-select
									v-model="selected_number_digits"
									:items="number_digits"
									:menu-props="{ bottom: true, offsetY: true}"
									:color="color"
									:item-color="color"
									background-color="#FAFAFA"
									outlined
									dense
									hide-details
									@change="onChange()"
								>
								</v-select>
							</v-col>
							<v-col v-if="selected_numbering_style && selected_numbering_style.id === 0" :cols="$vuetify.breakpoint.smAndDown ? 12:4">
								<div class="item-text">Prefix</div>
								<v-text-field
									v-model="prefix"
									:color="color"
									background-color="#FAFAFA"
									outlined
									dense
									hide-details
								></v-text-field>
								<div style="text-align: right" class="optional-text">optional</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row class="ma-0" :align="`start`">
					<v-col class="py-0" :cols="$vuetify.breakpoint.smAndDown ? 12:3">
						<div class="title-text text-purple">Job defaults</div>
						<div class="content-text text-grey">The following settings only apply to new jobs</div>
					</v-col>
					<v-col class="py-0" :cols="$vuetify.breakpoint.smAndDown ? 12:9">
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4">
								<div class="item-text">Default job type</div>
								<v-select
									v-model="selected_job_types"
									:items="job_types"
									:menu-props="{ bottom: true, offsetY: true}"
									:color="color"
									:item-color="color"
									item-value="id"
									item-text="desc"
									background-color="#FAFAFA"
									outlined
									dense
									hide-details
									@change="onChange()"
								>
								</v-select>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4">
								<div class="item-text">Default billing cycle</div>
								<v-select
									v-model="selected_billingcycle"
									:items="billingcycle_list"
									:menu-props="{ bottom: true, offsetY: true}"
									:color="color"
									:item-color="color"
									item-value="id"
									item-text="desc"
									background-color="#FAFAFA"
									outlined
									dense
									hide-details
									@change="onChange()"
								>
								</v-select>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4">
								<div class="container-row">
									<div class="item-text">Opening fee</div>
									<v-tooltip top max-width="calc(55%)" z-index="11">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on" style="height:20px">
												<InfoOutline width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
											</div>
										</template>
										<span>Use this to apply the same fee to every new job created.</span>
									</v-tooltip>
								</div>
								<v-text-field
									v-model="open_fee"
									:color="color"
									prefix="$"
									background-color="#FAFAFA"
									outlined
									dense
									hide-details
									type="number"
									min="0"
									oninput="if(this.value < 0) this.value = '0.00';"
									@change="onNumberChange($event)"
								></v-text-field>
							</v-col>
						</v-row>
						<v-checkbox
							class="mx-2"
							v-model="deadline_mandatory"
							:color="color"
							hide-details
							dense
							@change="onChange()"
						>
							<template v-slot:label>
								<span class="item-text">Make Deadline mandatory for all users</span>
							</template>
						</v-checkbox>
						<v-checkbox
							class="mx-2"
							v-model="clone_phases_tasks"
							:color="color"
							hide-details
							dense
							@change="onChange()"
						>
							<template v-slot:label>
								<span class="item-text">Clone phases and tasks</span>
							</template>
						</v-checkbox>
						<v-radio-group
							class="mx-2"
							v-model="accexec"
							column
							dense
							@change="onChange()"
						>
							<v-radio
								:value="'client_accexec'"
								:color="color"
							>
								<template v-slot:label>
									<span class="item-text">
										Prefills the
										<span style="font-weight:700">Account Executive</span>
										field with the default Client contact
									</span>
								</template>
							</v-radio>
							<v-radio
								value="'use_accexec'"
								:color="color"
							>
								<template v-slot:label>
									<span class="item-text">
										Prefills the
										<span style="font-weight:700">Account Executive</span>
										field with the current User
									</span>
								</template>
							</v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<v-row class="ma-0 pb-10" :align="`start`">
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3">
						<div class="title-text text-purple">Items on Jobs</div>
						<div class="content-text text-grey">The following settings only apply to new items on old and existing jobs </div>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:9">
						<v-checkbox
							class="mx-2"
							v-model="fractional_itemrates"
							:color="color"
							hide-details
							dense
							@change="onChange()"
						>
							<template v-slot:label>
								<span class="mr-2 item-text">Use fractional item rates</span>
								<v-tooltip top max-width="calc(55%)" z-index="11">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
										</div>
									</template>
									<span>Allows item rates of more than 2 decimal places. Eg, $1.23.</span>
								</v-tooltip>
							</template>
						</v-checkbox>
						<v-checkbox
							class="mx-2"
							v-model="partial_items"
							:color="color"
							hide-details
							dense
							@change="onChange()"
						>
							<template v-slot:label>
								<span class="mr-2 item-text">Allow partial items</span>
								<v-tooltip top max-width="calc(55%)" z-index="11">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
										</div>
									</template>
									<span>Allows partial items. Eg, 1.5 metres of fabric.</span>
								</v-tooltip>
							</template>
						</v-checkbox>
					</v-col>
				</v-row>
			</div>
		</div>
		<LastNumberComfirmDialog
			v-if="last_number_visible"
			:visible="last_number_visible" 
			:color="'error'"
			:textColor="color"
			:title="'Change in Job numbering system'" 
			:content="last_number_content"
			:last_number="last_number"
			:cancel="'Go back'"
			:ok="'Fix problem'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="last_number_visible = false"
			@ok="onSave($event)"
		/>
		<DeleteConfirmDialog 
			v-if="unsaved_visible"
			:visible="unsaved_visible" 
			:color="'error'"
			:title="`Your changes have not been saved`" 
			:content="'Are you sure you want to leave this page without saving changes?'"
			:cancel="'Go back'"
			:ok="'Yes, leave'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="unsaved_visible = false"
			@ok="onLeave()"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import SaveIcon from "@/components/icons/save.vue";
import InfoOutline from "@/components/icons/info_outline";
import LastNumberComfirmDialog from "@/views/settings/job/job_last_number_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

const Numbering = [
	{
		key: 0,
		title: ['Example Job created:', 'Example next Job created:'],
		contentA: ['Job number'],
		contentB: ['Job number'],
		text: 'Global numbering means every job is numbered sequentially and in increasing order. '
	},
	{
		key: 1,
		title: ['Example Job created:', 'Example next Job created:'],
		contentA: ['Client Prefix', 'Job number'],
		contentB: ['Another Client Prefix', 'Job number'],
		text: 'Client prefix is first 3 letters of the Client Name on this job. With system wide numbering, job numbers are sequential across the data base.'
	},
	{
		key: 2,
		title: ['Example Job created:', 'Example Job created:'],
		contentA: ['Client Prefix', 'Job number'],
		contentB: ['Another Client Prefix', 'Job number'],
		text: 'Client prefix is first 3 letters of the Client Name on this job. With client numbering, job numbers are sequential per client.'
	},
	{
		key: 3,
		title: ['Example Job created for parent client ABC:', 'Example next Job for XYZ, parent client ABC:'],
		contentA: ['Client Prefix', 'Job number'],
		contentB: ['Another Client Prefix', 'Job number'],
		text: 'Some clients are grouped under parent clients. When Parent numbering is used, all jobs for clients under a parent client are numbered with Parent prefix.'
	},
	{
		key: 4,
		title: ['Example Job created for parent client ABC:', 'Example next Job for XYZ, parent client ABC:'],
		contentA: ['Parent Client Prefix', 'Job number'],
		contentB: ['Use Parent client prefix', 'Job number'],
		text: 'Some clients are grouped under parent clients. When Parent numbering is used, all jobs for clients under a parent client are numbered with Parent prefix. With system wide numbering, job numbers are sequential across the data base.'
	},
];

const Number_Digits = [1,2,3,4,5,6,7,8,9,10];

export default {
	name: 'JobSettings',
	props: {
		color: {
			type: String,
			default: ''
		}
	},
	components: {
		ProgressLinear,
		SaveIcon,
		InfoOutline,
		LastNumberComfirmDialog,
		DeleteConfirmDialog
	},
	data() {
		this.number_digits = Number_Digits;

		return {
			error_msg: '',
			loading: false,
			isChanged: false,

			origin_job_settings: null,
			origin_selected_numbering_style: null,
			numbering_style: [],
			selected_numbering_style: null,
			selected_number_digits: 3,

			job_types: [],
			selected_job_types: null,

			billingcycle_list: [],
			selected_billingcycle: 0,
			prefix: '',
			open_fee: '0.00',

			deadline_mandatory: true,
			fractional_itemrates: true,
			partial_items: true,
			accexec: true,
			clone_phases_tasks: true,

			last_number_visible: false,
			last_number_content: '',
			last_number: 0,

			unsaved_visible: false
		};
	},
	async created() {
		await this.getMeta();
		await this.getJobTypeList();
		this.getJobSettingConfig();
	},
	computed: {
		styleTextObj() {
			let numbering_text = null;

			if (this.selected_numbering_style) {
				const numbering = Numbering.filter(n => { return n.key === this.selected_numbering_style.id });
				numbering_text = numbering[0];
			}
			
			return numbering_text;
		},
		numberA() {
			let number_arr  = [];

			if (this.selected_numbering_style && this.selected_numbering_style.id === 0) {
				const pre = this.prefix;
				const number = (this.last_number).toString();

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${pre}${number_str}${number}`;
				number_arr.push(number_str);
			}

			if (this.selected_numbering_style && this.selected_numbering_style.id === 1) {
				const number = (this.last_number).toString();

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${number_str}${number}`;

				number_arr.push('ABC')
				number_arr.push(number_str);
			}

			if (this.selected_numbering_style && this.selected_numbering_style.id === 2) {
				const number = (this.last_number).toString();

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${number_str}${number}`;

				number_arr.push('ABC')
				number_arr.push(number_str);
			}

			if (this.selected_numbering_style && (this.selected_numbering_style.id === 3 || this.selected_numbering_style.id === 4)) {
				const number = '1';

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${number_str}${number}`;

				number_arr.push('ABC')
				number_arr.push(number_str);
			}

			return number_arr;
		},
		numberB() {
			let number_arr  = [];

			if (this.selected_numbering_style && this.selected_numbering_style.id === 0) {
				const pre = this.prefix;

				const number = (this.last_number + 1).toString();

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${pre}${number_str}${number}`;
				number_arr.push(number_str);
			}

			if (this.selected_numbering_style && this.selected_numbering_style.id === 1) {
				const number = (this.last_number + 1).toString();

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${number_str}${number}`;

				number_arr.push('XYZ')
				number_arr.push(number_str);
			}

			if (this.selected_numbering_style && this.selected_numbering_style.id === 2) {
				const number = (this.last_number + 1).toString();

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${number_str}${number}`;

				number_arr.push('XYZ')
				number_arr.push(number_str);
			}

			if (this.selected_numbering_style && (this.selected_numbering_style.id === 3 || this.selected_numbering_style.id === 4)) {
				const number = '2';

				let number_str = '';
				for (let index = 0; index < this.selected_number_digits - number.length; index++) {
					number_str += '0';
				}
				number_str = `${number_str}${number}`;

				number_arr.push('XYZ')
				number_arr.push(number_str);
			}

			return number_arr;
		}
	},
	watch: {
		open_fee() {
			this.onChange();
		},
		prefix(newVal) {
			if (newVal !== this.origin_job_settings.prefix) {
				this.onChange();
			}
		},
		isChanged() {
			this.$emit('change', this.isChanged);
		}
	},
	methods: {
		async getMeta() {
			this.loading = true;

			const url = '/api/config/setup/job/meta';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.billingcycle_list = data.billing_cycle;

						const numbering = data.job_numbering;
						numbering.forEach((n, index) => {
							n['id'] = index;
						});
						this.numbering_style = numbering;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getJobTypeList() {
			this.loading = true;

			const params = [];
			params.push("include_inactive=false");

			let url = "/api/config/jobs/jobtype";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.job_types = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getJobSettingConfig() {
			this.loading = true;

			const url = '/api/config/setup/job/';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.origin_job_settings = data;
						this.origin_selected_numbering_style = this._getNumberingStyle(data.use_clientprefix, data.systemwide_numbering);
						this.selected_numbering_style = this._getNumberingStyle(data.use_clientprefix, data.systemwide_numbering);
						this.selected_number_digits = data.digits;

						this.selected_job_types = data.default_jobtype;
						this.selected_billingcycle = data.default_billingcycle;
						this.prefix = data.prefix;
						this.open_fee = data.open_fee;

						this.deadline_mandatory = data.deadline_mandatory;
						this.fractional_itemrates = data.fractional_itemrates;
						this.partial_items = data.partial_items;
						this.accexec = data.use_accexec ? 'use_accexec':'client_accexec';
						this.last_number = data.last_number;
						this.clone_phases_tasks = data.clone_phases_tasks;
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onClose() {
			if (this.isChanged) {
				this.unsaved_visible = true;
			} else {
				this.$emit('close');
			}
		},
		onLeave() {
			this.unsaved_visible = false;
			this.$emit('close');
		},
		onNumberChange(value) {
			this.open_fee = Number.parseFloat(value).toFixed(2);
		},
		onChange() {
			this.isChanged = this.isChange();
		},
		onSaveChange() {
			if (!this.isChanged) return;

			if (this.isChanged) {
				if (this.selected_numbering_style.id === 0 || this.selected_numbering_style.id === 1 || this.selected_numbering_style.id === 2) {
					this.last_number_content = `Selecting ‘${this.selected_numbering_style.desc}’ means JobBag will use the ‘last number used’ below to determine the next Job number.`;
					this.last_number_visible = true;
				} else {
					this._save_changes();
				}
			}
		},
		onSave(last_number) {
			this.last_number = Number(last_number);
			this._save_changes();
		},
		isChange() {
			let is_change_tmp = false;

			if (this.origin_selected_numbering_style.id !== this.selected_numbering_style.id) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.digits !== this.selected_number_digits) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.prefix !== this.prefix) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.default_jobtype !== this.selected_job_types) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.default_billingcycle !== this.selected_billingcycle) {
				is_change_tmp = true;
			} else if(Number(this.origin_job_settings.open_fee) !== Number(this.open_fee)) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.deadline_mandatory !== this.deadline_mandatory) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.clone_phases_tasks !== this.clone_phases_tasks) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.fractional_itemrates !== this.fractional_itemrates) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.partial_items !== this.partial_items) {
				is_change_tmp = true;
			} else if (this.origin_job_settings.use_accexec !== ( this.accexec === 'client_accexec' ? false : true )) {
				is_change_tmp = true;
			} else {
				is_change_tmp = false;
			}

			return is_change_tmp;
		},
		_save_changes() {
			const param_obj = {};
			param_obj['open_empty_worklist'] = this.origin_job_settings.open_empty_worklist;
			param_obj['default_jobtype'] = this.selected_job_types;
			param_obj['default_billingcycle'] = this.selected_billingcycle;
			param_obj['partial_items'] = this.partial_items;
			param_obj['fractional_itemrates'] = this.fractional_itemrates;
			param_obj['warn_deadlineyears'] = this.origin_job_settings.warn_deadlineyears;
			param_obj['deadline_mandatory'] = this.deadline_mandatory;
			param_obj['clone_phases_tasks'] = this.clone_phases_tasks;
			param_obj['open_fee'] = Number.parseFloat(this.open_fee);
			param_obj['dont_askforfee'] = this.origin_job_settings.dont_askforfee;
			param_obj['number_documents'] = this.origin_job_settings.number_documents;
			param_obj['use_clientprefix'] = this.selected_numbering_style.client_prefix;
			param_obj['systemwide_numbering'] = this.selected_numbering_style.system_wide_numbering;
			param_obj['prefix'] = this.prefix;
			param_obj['digits'] = this.selected_number_digits;
			param_obj['checkdigit'] = this.origin_job_settings.checkdigit;
			param_obj['autoalloc'] = this.origin_job_settings.autoalloc;
			param_obj['use_accexec'] = this.accexec === 'use_accexec' ? true : false;
			param_obj['ticket_landscape'] = this.origin_job_settings.ticket_landscape;
			param_obj['autoopen_keywords'] = this.origin_job_settings.autoopen_keywords;
			param_obj['default_keywords'] = this.origin_job_settings.default_keywords;
			param_obj['last_number'] = this.last_number;

			const url = '/api/config/setup/job/';

			axios
				.post(url, param_obj, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						if (this.last_number_visible) {
							this.last_number_visible = false;
						}

						if (this.isChanged) {
							this.isChanged = false;
						}

						this.getJobSettingConfig();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_getNumberingStyle(client_prefix, system_wide_numbering) {
			const style = this.numbering_style.filter(style => { return style.client_prefix === client_prefix && style.system_wide_numbering === system_wide_numbering });
			
			return style[0];
		}
	}
}
</script>
<style lang="scss" scoped>
.list-wrap {
	overflow: auto;
}
.list-wrap-container {
  height: 99%;
}
.title-text {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.25px;
}
.content-text {
	font-family: Roboto;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.4px;
}
.number-text {
	font-family: Roboto;
	font-size: 24px;
	font-weight: 400;
	line-height: 32px;
}
.item-text {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(55, 73, 95, 1);
}

.container-row {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}

.text-purple {
	color: #605AF6;
}
.text-grey {
	color: rgba(25, 42, 62, 0.5);
}
.text-black {
	color: rgba(25, 42, 62, 0.7);
}
.bg-color {
	background-color: #FAFAFA;
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}

</style>